import { Box, Paper, ThemeProvider, useTheme } from "@mui/material";
import { ThemeContextProvider, useThemeContext } from "../../Themes/ThemeContext";
import darkTheme from "../../Themes/DarkTheme";
import lightTheme from "../../Themes/LightTheme";
import Navbar from "../Navbar/Navbar";



export default function Background({ children }) {
    
    const { theme } = useThemeContext();
    const isDarkMode = theme.mode === "dark";

    console.log("Is dark mode", isDarkMode, isDarkMode ? darkTheme : lightTheme);
    return (
        <ThemeProvider theme={ isDarkMode ? darkTheme : lightTheme }>
            <Paper
                sx={{
                    borderRadius: "0px",
                    position: "absolute",
                    width: "100dvw",
                    minHeight: "100dvh",
                    top: 0,
                    zIndex: -1,

                    overflowY: "scroll",
                    overflowX: "hidden",
                    scrollBehavior: "smooth",

                    '&::-webkit-scrollbar': {
                        display: 'none'
                    },
                    // Hide scrollbar for IE, Edge and Firefox
                    msOverflowStyle: 'none', // IE and Edge
                    scrollbarWidth: 'none', // Firefox


                    // "scrollbar-width": "none",
                    // "-ms-overflow-style": "none",
                    // ".container::-webkit-scrollbar": {
                    //     display: "none"
                    // }
                }}
            >
                <Navbar />
                {children}
            </Paper>
        </ThemeProvider>
    );
}